import {
  AppDivider,
  AppEmptyState,
  AppScreenScaffold,
  AppSearchField,
  Icon,
  IconButton,
  type IconName,
} from '@core/designsystem';
import { CATEGORY_TITLE, type SearchCategory, type SearchResultItem, type SearchState } from './types';
import type { SearchActions } from './useSearch';
import './search.css';

const CATEGORY_ICON: Record<SearchCategory, IconName> = {
  cases: 'folder',
  tasks: 'checklist',
  documents: 'picture_as_pdf',
  clients: 'person',
};

/**
 * Глобальный поиск — «Структура» §10.
 *
 * Своя шапка вместо `AppTopBar`: на месте заголовка стоит поле ввода. Это одно из двух
 * мест, где шапка собрана отдельно, и оба раза осознанно — docs/DESIGN.md,
 * «Переиспользование».
 */
export function SearchScreen({
  state,
  actions,
  onBack,
  onOpen,
}: {
  state: SearchState;
  actions: SearchActions;
  onBack: () => void;
  onOpen: (item: SearchResultItem) => void;
}) {
  return (
    <AppScreenScaffold
      topBar={
        <header className="search__bar">
          <IconButton icon="arrow_back" label="Назад" onClick={onBack} />
          <div className="search__field">
            <AppSearchField
              value={state.query}
              onChange={actions.setQuery}
              placeholder="Дела, задачи, документы, клиенты"
              autoFocus
            />
          </div>
        </header>
      }
    >
      {state.isRecent && state.entries.length > 0 ? (
        <p className="search__hint">Недавнее</p>
      ) : null}

      {state.isTooShort ? <AppEmptyState icon="search" text="Нужно хотя бы две буквы" /> : null}

      {!state.isTooShort && state.entries.length === 0 ? (
        <AppEmptyState
          icon="search"
          text={state.isRecent ? 'Здесь появится недавнее' : 'Ничего не нашлось'}
        />
      ) : null}

      <div className="search__list">
        {state.entries.map((entry) =>
          entry.kind === 'header' ? (
            <h2 key={`header-${entry.category}`} className="search__header">
              {CATEGORY_TITLE[entry.category]}
            </h2>
          ) : (
            <div key={`${entry.result.category}-${entry.result.id}`}>
              <button
                type="button"
                className="search-row"
                onClick={() => onOpen(entry.result)}
              >
                <Icon
                  name={CATEGORY_ICON[entry.result.category]}
                  size={22}
                  className="search-row__icon"
                />
                <span className="search-row__texts">
                  <span className="search-row__title">
                    {entry.result.title}
                    {/* Избранный документ помечен звездой и здесь — D-20. */}
                    {entry.result.isFavorite ? (
                      <Icon name="star" filled size={16} className="search-row__star" />
                    ) : null}
                  </span>
                  {entry.result.subtitle ? (
                    <span className="search-row__subtitle">{entry.result.subtitle}</span>
                  ) : null}
                </span>
              </button>
              <AppDivider withIcon />
            </div>
          ),
        )}
      </div>
    </AppScreenScaffold>
  );
}
